// Handle mobile viewport height dynamically
// Uses visualViewport API to account for browser chrome

export function initViewport(): void {
  const app = document.getElementById('app')
  const gameContainer = document.getElementById('game-container')

  const setViewportHeight = () => {
    // Use visualViewport if available (accounts for browser chrome)
    // Also try innerHeight as fallback since visualViewport can be unreliable
    let vh = window.innerHeight

    if (window.visualViewport) {
      // Use the smaller of visualViewport and innerHeight
      vh = Math.min(window.visualViewport.height, window.innerHeight)
    }

    // Detect if mobile (rough check)
    const isMobile = window.innerWidth < 768

    // Set CSS variable
    document.documentElement.style.setProperty('--app-height', `${vh}px`)

    // Also directly set heights on elements for reliability
    if (app) {
      app.style.height = `${vh}px`
      app.style.maxHeight = `${vh}px`
      app.style.overflow = 'hidden'
    }
    if (gameContainer) {
      // Subtract more space on mobile for browser chrome
      const padding = isMobile ? 80 : 50
      const containerHeight = vh - padding
      gameContainer.style.height = `${containerHeight}px`
      gameContainer.style.maxHeight = `${containerHeight}px`
      gameContainer.style.overflow = 'hidden'
    }
  }

  // Set initial height after a small delay to ensure DOM is ready
  setTimeout(setViewportHeight, 50)
  setViewportHeight()

  // Update on resize and viewport changes
  window.addEventListener('resize', setViewportHeight)
  window.addEventListener('orientationchange', setViewportHeight)

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setViewportHeight)
    window.visualViewport.addEventListener('scroll', setViewportHeight)
  }
}
